<template>
  <div class="report-section report-section-bill-overview">
    <div v-if="reportData.options?.name || reportData.name" class="section-title">{{ reportData.options?.name || reportData.name }}</div>
    <div v-if="reportData.options?.description || reportData.description" class="section-description">{{ reportData.options?.description || reportData.description }}</div>
    <overview-index
      ref="template"
      :is-template="true"
      :template-params="reportData.queryParams || reportData.options?.queryParams"
      :is-template-edit="isTemplateEdit"
      :default-date="defaultDate"
      :default-project-id="isTemplateEdit ? '' : scopeParams.project_id || ''"
      :default-domain-id="isTemplateEdit ? '' : scopeParams.domain_id || ''"
      :defaultDateMode="dateMode || 'month'" />
  </div>
</template>

<script>
import OverviewIndex from '@Bill/views/overview/components/index'

export default {
  name: 'ReportBillOverview',
  components: {
    OverviewIndex,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    isTemplateEdit: {
      type: Boolean,
      default: false,
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
    reportType: {
      type: String,
    },
  },
  computed: {
    defaultDate () {
      let startDate, endDate, year
      if (this.reportType === 'month') {
        // 月报：使用上个月
        const lastMonth = this.$moment().subtract(1, 'month')
        year = lastMonth.format('YYYY')
        // month = lastMonth.format('MM')
        startDate = lastMonth.startOf('month').format('YYYY-MM-DD') + 'TZ'
        endDate = lastMonth.endOf('month').format('YYYY-MM-DD') + 'TZ'
      } else {
        // 日报：保持原状，使用当前月
        year = this.$moment().format('YYYY')
        // month = this.$moment().format('MM')
        startDate = this.$moment().startOf('month').format('YYYY-MM-DD') + 'TZ'
        endDate = this.$moment().endOf('month').format('YYYY-MM-DD') + 'TZ'
      }
      return {
        year,
        // month,
        data_type: 'day',
        start_date: startDate,
        end_date: endDate,
      }
    },
    dateMode () {
      return this.reportType === 'month' ? 'last_month' : 'month'
    },
  },
  methods: {
    getTemplateParams () {
      return this.$refs.template.getTemplateParams()
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 15px;
}
.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
